import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";

const links = [
    { to: "/", label: "Home" },
    { to: "/services", label: "Services" },
    { to: "/how-it-works", label: "How It Works" },
    { to: "/about", label: "About" },
    { to: "/contact", label: "Contact" },
];

export default function Navbar() {
    const [open, setOpen] = useState(false);

    return (
        <header
            className="sticky top-0 z-50 backdrop-blur-xl bg-white/90 border-b border-[#E2E8F0]"
            data-testid="site-navbar"
        >
            <div className="max-w-7xl mx-auto px-6 lg:px-8 h-16 md:h-20 flex items-center justify-between">
                <Link
                    to="/"
                    className="brand-wordmark text-xl md:text-2xl tracking-tight text-[#0A2540]"
                    data-testid="nav-logo-link"
                >
                    <span className="text-[#C5A059]">EZ</span>{" "}
                    <span>Permit Express</span>
                </Link>

                <nav className="hidden md:flex items-center gap-8" data-testid="nav-desktop">
                    {links.map((l) => (
                        <NavLink
                            key={l.to}
                            to={l.to}
                            end={l.to === "/"}
                            className={({ isActive }) =>
                                `link-underline text-sm font-medium tracking-wide text-[#0A2540] ${isActive ? "active" : ""}`
                            }
                            data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                        >
                            {l.label}
                        </NavLink>
                    ))}
                </nav>

                <div className="hidden md:flex items-center gap-3">
                    <a
                        href="tel:9512493125"
                        className="flex items-center gap-2 text-sm text-[#0A2540] hover:text-[#C5A059] transition-colors"
                        data-testid="nav-phone-link"
                    >
                        <Phone size={16} className="text-[#C5A059]" />
                        951-249-3125
                    </a>
                    <Link
                        to="/contact"
                        className="btn-gold px-5 py-2.5 text-sm font-medium"
                        data-testid="nav-cta-quote"
                    >
                        Get a Quote
                    </Link>
                </div>

                <button
                    className="md:hidden p-2 text-[#0A2540]"
                    onClick={() => setOpen((v) => !v)}
                    aria-label="Toggle menu"
                    data-testid="nav-mobile-toggle"
                >
                    {open ? <X size={24} /> : <Menu size={24} />}
                </button>
            </div>

            {open && (
                <div
                    className="md:hidden border-t border-[#E2E8F0] bg-white"
                    data-testid="nav-mobile-menu"
                >
                    <div className="px-6 py-4 flex flex-col gap-4">
                        {links.map((l) => (
                            <NavLink
                                key={l.to}
                                to={l.to}
                                end={l.to === "/"}
                                onClick={() => setOpen(false)}
                                className={({ isActive }) =>
                                    `text-base font-medium ${isActive ? "text-[#C5A059]" : "text-[#0A2540]"}`
                                }
                                data-testid={`nav-mobile-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                            >
                                {l.label}
                            </NavLink>
                        ))}
                        <a
                            href="tel:9512493125"
                            className="flex items-center gap-2 text-sm text-[#0A2540]"
                        >
                            <Phone size={16} className="text-[#C5A059]" /> 951-249-3125
                        </a>
                        <Link
                            to="/contact"
                            onClick={() => setOpen(false)}
                            className="btn-gold px-5 py-2.5 text-sm font-medium text-center"
                            data-testid="nav-mobile-cta-quote"
                        >
                            Get a Quote
                        </Link>
                    </div>
                </div>
            )}
        </header>
    );
}
